export default __webpack_public_path__ + "static/media/itas-assicurazioni-it.8439833d.png";